import { useUserSaveItem, useUserSaveType } from "@/app/layout/useUserSaves";
import PillButton from "@/app/shared/PillButton";
import { IconButton, Link, Menu } from "@mui/material";
import { useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import StarIcon from "@mui/icons-material/Star";
import { UserSaveType } from "@/backend/user/models/UserSave";
import { SavesList } from "./SavesList";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

export function SaveButton({
  type,
  currentKey,
  compactOnMobile,
  iconOnly,
}: {
  type: UserSaveType;
  currentKey: string;
  compactOnMobile?: boolean;
  iconOnly?: boolean;
}) {
  const { isSaved, isDisabled, ToggleSave } = useUserSaveItem({
    type: type,
    key: currentKey,
  });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const { userSaves } = useUserSaveType(type);
  const hasUserSaves = userSaves.length > 0;
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <PillButton
        sx={{
          backgroundColor: type === "AD" ? "white" : "grey.100",
        }}
        compact={type === "SEARCH"}
        iconOnly={iconOnly}
        compactOnMobile={compactOnMobile}
        startIcon={
          type === "AD" ? (
            isSaved ? (
              <FavoriteIcon />
            ) : (
              <FavoriteBorderIcon />
            )
          ) : isSaved ? (
            <StarIcon />
          ) : (
            <StarBorderIcon />
          )
        }
        endIcon={
          !iconOnly &&
          hasUserSaves && (
            <IconButton
              component="div"
              sx={{
                margin: -2,
              }}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleOpenMenu(event);
              }}
            >
              <ArrowDropDownIcon />
            </IconButton>
          )
        }
        onClick={async (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (!iconOnly && isSaved) {
            handleOpenMenu(event);
          } else {
            await ToggleSave();
          }
        }}
        disabled={isDisabled}
        loading={isDisabled}
      >
        {!iconOnly && <>{isSaved ? "Saved" : "Save"}</>}
      </PillButton>
      {hasUserSaves && !iconOnly && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleCloseMenu}
          anchorOrigin={{
            horizontal: "center",
            vertical: "bottom",
          }}
          transformOrigin={{
            horizontal: "center",
            vertical: "top",
          }}
          keepMounted
          sx={{
            ".MuiList-root": {
              display: "flex",
              flexDirection: "column",
            },
          }}
        >
          <SavesList type={type} currentKey={currentKey} />
          <PillButton
            component={Link}
            href="/members/watchlist"
            endIcon={<NavigateNextIcon />}
            compact
            sx={{
              backgroundColor: "grey.100",
              margin: 2,
              alignSelf: "end",
            }}
          >
            See All
          </PillButton>
        </Menu>
      )}
    </>
  );
}
